<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.7,6.299999940395355C13.7,6.299999940395355,8.7,1.2999999403953553,8.7,1.2999999403953553C8.5,1.0999999403953553,8.3,0.9999999403953553,8,0.9999999403953553C7.7,0.9999999403953553,7.5,1.0999999403953553,7.3,1.2999999403953553C7.3,1.2999999403953553,2.3,6.299999940395355,2.3,6.299999940395355C2.1,6.499999940395355,2,6.699999940395355,2,6.999999940395355C2,7.599999940395355,2.5,7.999999940395355,3,7.999999940395355C3.3,7.999999940395355,3.5,7.899999940395356,3.7,7.699999940395355C3.7,7.699999940395355,7,4.399999940395356,7,4.399999940395356C7,4.399999940395356,7,13.999999940395355,7,13.999999940395355C7,14.599999940395355,7.4,14.999999940395355,8,14.999999940395355C8.6,14.999999940395355,9,14.599999940395355,9,13.999999940395355C9,13.999999940395355,9,4.399999940395356,9,4.399999940395356C9,4.399999940395356,12.3,7.699999940395355,12.3,7.699999940395355C12.5,7.899999940395356,12.7,7.999999940395355,13,7.999999940395355C13.6,7.999999940395355,14,7.599999940395355,14,6.999999940395355C14,6.699999940395355,13.9,6.499999940395355,13.7,6.299999940395355C13.7,6.299999940395355,13.7,6.299999940395355,13.7,6.299999940395355C13.7,6.299999940395355,13.7,6.299999940395355,13.7,6.299999940395355Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowUp',
} as DefineComponent
</script>
